/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Reliability_Data_Col_DateInputs */

const en_home_reliability_data_col_date = /** @type {(inputs: Home_Reliability_Data_Col_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const zh_hans1_home_reliability_data_col_date = /** @type {(inputs: Home_Reliability_Data_Col_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期`)
};

const pt_br2_home_reliability_data_col_date = /** @type {(inputs: Home_Reliability_Data_Col_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const es_home_reliability_data_col_date = /** @type {(inputs: Home_Reliability_Data_Col_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha`)
};

const fr_home_reliability_data_col_date = /** @type {(inputs: Home_Reliability_Data_Col_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const de_home_reliability_data_col_date = /** @type {(inputs: Home_Reliability_Data_Col_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const ru_home_reliability_data_col_date = /** @type {(inputs: Home_Reliability_Data_Col_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата`)
};

const it_home_reliability_data_col_date = /** @type {(inputs: Home_Reliability_Data_Col_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Home_Reliability_Data_Col_DateInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const home_reliability_data_col_date = /** @type {((inputs?: Home_Reliability_Data_Col_DateInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Reliability_Data_Col_DateInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_home_reliability_data_col_date(inputs)
	if (locale === "pt-BR") return pt_br2_home_reliability_data_col_date(inputs)
	if (locale === "es") return es_home_reliability_data_col_date(inputs)
	if (locale === "fr") return fr_home_reliability_data_col_date(inputs)
	if (locale === "de") return de_home_reliability_data_col_date(inputs)
	if (locale === "ru") return ru_home_reliability_data_col_date(inputs)
	if (locale === "it") return it_home_reliability_data_col_date(inputs)
	return en_home_reliability_data_col_date(inputs)
});